import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'

import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css' // optional for styling
import 'tippy.js/themes/light.css'
import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist"

createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.vue', { eager: true })
        return pages[`./Pages/${name}.vue`]
    },
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueTippy)
            .use(ZiggyVue)
            .mount(el)
    },
})
